import * as Yup from 'yup';

export const argumentFormValidationSchema = () => {
  const fields: any = {
    comment: Yup.string().trim().nullable(),
  };

  return Yup.object().shape(fields);
};
